const useGetAuthSns = () => {

    const getRedirectUrl = (type) => {
        window.location.href = `${process.env.REACT_APP_BACKEND_URL}/auth/${type}`
    }

    return [getRedirectUrl]
}

export default useGetAuthSns